import { render, staticRenderFns } from "./TriggerCustomPreview.vue?vue&type=template&id=36fed820&scoped=true"
import script from "./TriggerCustomPreview.vue?vue&type=script&lang=ts"
export * from "./TriggerCustomPreview.vue?vue&type=script&lang=ts"
import style0 from "./TriggerCustomPreview.vue?vue&type=style&index=0&id=36fed820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fed820",
  null
  
)

export default component.exports